import labelStyles from './label';
import valueStyles from './value';
import statsStyles from './stats';
import amountStyles from './amount';

const styles = (theme) => ({
  amount: amountStyles(theme),
  label: labelStyles(theme),
  stats: statsStyles(theme),
  value: valueStyles(theme),
});

export default styles;
